import React, { useState } from "react";
import { TfiClose } from "react-icons/tfi";
import feedname from "../assets/feedname.png";
import ColourVerySad from "../assets/ColourVerySad.png";
import ColourSad from "../assets/ColourSad.png";
import ColourAverage from "../assets/ColourAverage.png";
import ColourSurprised from "../assets/ColourSurprised.png";
import ColourCool from "../assets/ColourCool.png";
import BlackVerySad from "../assets/BlackVerySad.png";
import BlackSad from "../assets/BlackSad.png";
import BlackAverage from "../assets/BlackAverage.png";
import BlackSurprised from "../assets/BlackSurprised.png";
import BlackCool from "../assets/BlackCool.png";
import axios from "axios";
import { postFeedbackurl } from "../Services/BackendUrl";
import { FcOk } from "react-icons/fc";
import "./Feedback.css";

const Feedback = ({ showModal, handleClose }) => {
  const [toaster, setToast] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    profession: "",
    message: "",
    starRating: 0,
  });

  const [errors, setErrors] = useState({
    fullName: "",
    profession: "",
    message: "",
    emoji: "",
  });

  const [selectedEmoji, setSelectedEmoji] = useState(null);

  const emojis = [
    { title: "Very Sad", colorImg: ColourVerySad, grayImg: BlackVerySad },
    { title: "Sad", colorImg: ColourSad, grayImg: BlackSad },
    { title: "Average", colorImg: ColourAverage, grayImg: BlackAverage },
    { title: "Surprised", colorImg: ColourSurprised, grayImg: BlackSurprised },
    { title: "Cool", colorImg: ColourCool, grayImg: BlackCool },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim())
      newErrors.fullName = "Full name is required.";
    if (!formData.profession.trim())
      newErrors.profession = "Profession is required.";
    if (!formData.message.trim()) newErrors.message = "Comment is required.";
    if (selectedEmoji === null)
      newErrors.emoji = "Please select your experience emoji.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      await axios.post(postFeedbackurl, formData);
      setToast(true);
      setTimeout(() => {
        setToast(false);
        handleClose();
      }, 3000);
      setFormData({
        fullName: "",
        profession: "",
        message: "",
        starRating: formData.starRating,
      });
    } catch(error) {
      console.error("Error submiting feedback:",error);
     }
    setSelectedEmoji(null);
    setErrors({});
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${showModal
          ? "opacity-100 visible backdrop-blur-sm bg-black bg-opacity-80"
          : "opacity-0 invisible"
        }`}
    >
      <div className="relative bg-white pt-4 pb-6 sm:pb-12 shadow-lg text-center w-full max-w-2xl mx-4 max-h-[100vh] overflow-y-auto">
        <div className="flex justify-between items-center px-6 sm:px-8 mb-4">
          <h2 className="text-lg tracking-wider text-gray-800 text-left font-langit">
            FEEDBACK
          </h2>
          <button
            className="border-none bg-white w-6 h-6 cursor-pointer"
            onClick={handleClose}
          >
            <TfiClose />
          </button>
        </div>

        <div
          style={{
            borderBottom: "1px solid #D7D7D7",
            marginBottom: "1rem",
            paddingBottom: "0.5rem",
          }}
        ></div>

        <h2 className="text-[24px] md:text-[40px] font-league font-light text-[#2C2C2C] mt-2">
          Tell us how your experience was...
        </h2>
        <p className="text-[10px] md:text-[14px] text-[#6E6E6E] mt-1 font-lufga">
          We'd love to hear from you — your feedback helps us <br /> improve and
          serve you better!
        </p>

        <div className="flex justify-center gap-3 mt-6">
          {emojis.map((emoji, index) => (
            <div key={index} className="flex flex-col items-center">
              <div
                onClick={() => {
                  setSelectedEmoji(index);
                  setFormData((prev) => ({ ...prev, starRating: index + 1 }));
                  setErrors((prev) => ({ ...prev, emoji: "" }));
                }}
                title={emoji.title}
                className="cursor-pointer flex items-center justify-center transition-all duration-300 hover:scale-110"
                style={
                  selectedEmoji === index
                    ? {
                      border: "1px solid #949494",
                      padding: "8px",
                      borderRadius: "9999px",
                      backgroundColor: "#ffffff",
                    }
                    : {}
                }
              >
                <div
                  className={`rounded-full flex items-center justify-center transition-all duration-300 ${selectedEmoji === index
                      ? "w-20 h-20"
                      : "w-14 h-14 mt-4 bg-[#D9D9D9] grayscale"
                    }`}
                  style={
                    selectedEmoji === index
                      ? {
                        background:
                          "linear-gradient(135deg, #8A46DC, #5540C9, #2A2CA1, #191D80, #0B0D3E)",
                      }
                      : {}
                  }
                >
                  <img
                    src={
                      selectedEmoji === index ? emoji.colorImg : emoji.grayImg
                    }
                    alt={emoji.title}
                    className={`transition-all duration-300 ${selectedEmoji === index ? "w-12 h-12" : "w-8 h-8"
                      }`}
                  />
                </div>
              </div>

              {selectedEmoji === index && (
                <div className="relative flex flex-col items-center mt-2">
                  <div
                    style={{
                      width: 0,
                      height: 0,
                      borderLeft: "8px solid transparent",
                      borderRight: "8px solid transparent",
                      borderBottom: "10px solid black",
                    }}
                  ></div>
                  <div className="text-[18px] font-league font-extralight tracking-wider text-white bg-black px-4 py-1">
                    {emoji.title.toUpperCase()}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {errors.emoji && (
          <p className="text-red-500 text-xs mt-2 font-lufga">{errors.emoji}</p>
        )}

        <div className="mt-6 space-y-3 mb-2 text-left text-sm text-[#2C2C2C] font-lufga px-6 sm:px-8">
          <div className="flex flex-col sm:flex-row gap-6">
            <div className="w-full flex flex-col gap-1">
              <label className="font-lufga">Full Name</label>
              <div className="flex items-center gap-2 bg-[#EBEBEB] rounded px-3 py-2">
                <img src={feedname} alt="User" className="w-3 h-3" />
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter your name..."
                  value={formData.fullName}
                  onKeyPress={(e) => {
                    if (formData.fullName.length === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                    if (!/^[A-Za-z\s]+$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  className="w-full bg-transparent font-lufga text-[14px] border-none outline-none"
                />
              </div>
              {errors.fullName && (
                <span className="text-red-500 text-xs mt-1">
                  {errors.fullName}
                </span>
              )}
            </div>

            <div className="w-full flex flex-col gap-1">
              <label>Profession</label>
              <div className="flex items-center gap-2 bg-[#EBEBEB] rounded px-3 py-2">
                <img src={feedname} alt="Job" className="w-3 h-3" />
                <input
                  type="text"
                  name="profession"
                  placeholder="Enter your Profession..."
                  value={formData.profession}
                  onKeyPress={(e) => {
                    if (formData.profession.length === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                    if (!/^[A-Za-z\s]+$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  className="w-full bg-transparent font-lufga text-[14px] border-none outline-none"
                />
              </div>
              {errors.profession && (
                <span className="text-red-500 text-xs mt-1">
                  {errors.profession}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="text-left text-sm font-lufga pt-4 px-6 sm:px-8 mt-5">
          <textarea
            rows="6"
            name="message"
            placeholder="Enter Comment..."
            value={formData.message}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded font-lufga border-none bg-[#EBEBEB] outline-none text-[14px]"
          ></textarea>
          {errors.message && (
            <span className="text-red-500 text-xs mt-1 block">
              {errors.message}
            </span>
          )}
        </div>

        <div className="px-6 sm:px-8">
          <button
            className="w-full cursor-pointer uppercase mt-4 bg-orange-500 tracking-wider text-white py-2 rounded border-none font-league text-[20px]"
            onClick={handleSubmit}
          >
            Submit
          </button>
          {toaster && (
            <div>
              <div
                style={{
                  backgroundColor: "#63F52066",
                  width: "100%",
                  padding: "20px",
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "20px",
                  color: "black",
                }}
              >
                <FcOk />
                Thank you! Your feedback has been successfully submitted
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Feedback;